import type { FeatureSet } from '../protocol/gen/warinspace/v2/server_to_client_pb.js';
import {
  flagsFrom,
  readOverrides,
  ringFromWire,
  withOverride,
  writeOverrides,
  type FlagView,
  type Overrides,
  type Ring,
} from './overrides';

function storage(): Storage | null {
  return typeof localStorage === 'undefined' ? null : localStorage;
}

export class FeatureState {
  ring = $state<Ring>('prod');
  flags = $state<readonly FlagView[]>([]);
  overrides = $state<Overrides>(readOverrides(storage()));

  private notify: (() => void) | null = null;

  get debuggable(): boolean {
    return this.ring !== 'prod';
  }

  enabled(key: string): boolean {
    return this.flags.some((flag) => flag.key === key && flag.enabled);
  }

  applyFromServer(set: FeatureSet): void {
    this.ring = ringFromWire(set.ring);
    this.flags = flagsFrom(set);
  }

  /** The server decides a flag, so an override is a request, not a local answer: it is stored, sent, and only believed once the next `FeatureSet` comes back. */
  onOverridesChanged(send: () => void): void {
    this.notify = send;
  }

  override(key: string, enabled: boolean | null): void {
    this.store(withOverride(this.overrides, key, enabled));
  }

  clearOverrides(): void {
    this.store({});
  }

  private store(next: Overrides): void {
    this.overrides = next;
    writeOverrides(storage(), next);
    this.notify?.();
  }
}

export const features = new FeatureState();
